import querystring from 'querystring';

var query = {};
if (typeof window !== 'undefined' && window.location && window.location.search) {
  query = querystring.parse(window.location.search.substring(1));
}
var query$1 = query;

export default query$1;
